import { Component, Input, OnInit } from '@angular/core';
import { AngularFirestore } from '@angular/fire/firestore';
import { AngularFireStorage } from '@angular/fire/storage';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { DialogService } from 'src/app/shared/services/dialog.service';

interface curso {
  adicionales: string[],
  cantArchivos: number,
  cantVentas: number,
  categoria: string,
  creador: string,
  descripcion: string,
  dictaEmpresa: boolean,
  dirigidoA: string,
  duracion: number,
  empresaDescripcion: string,
  empresaFoto: string,
  empresaId: string,
  empresaNombre: string,
  empresaResumen: string,
  fechaCreacion: Date,
  foto: string,
  idioma: string,
  instructorDescripcion: string,
  instructorFoto: string,
  instructorId: string,
  instructorNombre: string,
  instructorResumen: string,
  nivel: string,
  porcentajeDescuento: number,
  instructorPorcentaje: number,
  precioFinal: number,
  precioOriginal: number,
  publicado: boolean,
  queAprenderas: string[],
  resumen: string,
  titulo: string,
  ultimaEdicion: Date,
  ultimoEditor: string,
  valoracion: number,
}

interface instructor {
  id: string,
  nombre: string,
  foto: string,
  descripcion: string,
  resumen: string,
  categorias: string[],
  empresaId: string,
  empresaNombre: string,
  empresaDescripcion: string,
  empresaFoto: string,
  empresaResumen: string,
}

interface modulo {
  archivos: string[],
  descripcion: string,
  duracion: number,
  id: number,
  idVideo: number,
  numero: number,
  tipo: string,
  titulo: string,
  vigente: boolean,
}

@Component({
  selector: 'editar-curso-info',
  templateUrl: './editar-curso-info.component.html',
  styleUrls: ['./editar-curso-info.component.css']
})

export class EditarCursoInfoComponent implements OnInit {

  //spinner
  loaded = 0

  // infomacion del adminstrador:
  subscripcionUsuario: Subscription;

  constructor(
    private afs: AngularFirestore,
    private route: ActivatedRoute,
    private storage: AngularFireStorage,
    private router: Router,
    private dialogService: DialogService
  ) { }

  // Si vamos a editar entonces debe tener un id en la ruta
  id = this.route.snapshot.paramMap.get('id');

  // Si vamos a crear id == null

  // informacion de instructor

  instructor: instructor = {
    id: '',
    nombre: '',
    foto: '',
    descripcion: '',
    resumen: '',
    categorias: [],
    empresaId: '',
    empresaNombre: '',
    empresaDescripcion: '',
    empresaFoto: '',
    empresaResumen: '',
  }

  instructores: instructor[] = [];

  // informacion del curso;
  curso: curso = {
    adicionales: [],
    cantArchivos: 0,
    cantVentas: 0,
    categoria: '',
    creador: '',
    descripcion: '',
    dictaEmpresa: true,
    dirigidoA: '',
    duracion: 0,
    empresaDescripcion: '',
    empresaFoto: '',
    empresaId: '',
    empresaNombre: '',
    empresaResumen: '',
    fechaCreacion: new Date,
    foto: '',
    idioma: '',
    instructorDescripcion: '',
    instructorFoto: '',
    instructorId: '',
    instructorNombre: '',
    instructorResumen: '',
    porcentajeDescuento: 0,
    instructorPorcentaje: 50,
    nivel: "Intermedio",
    precioFinal: 0,
    precioOriginal: 0,
    publicado: true,
    queAprenderas: [],
    resumen: '',
    titulo: '',
    ultimaEdicion: new Date,
    ultimoEditor: '',
    valoracion: 0,
  }

  // Varibles globales
  categorias: string[];

  // informacion sesiones

  clases: modulo[] = [];
  duracion: number;

  // sesion -> clases[] -> modulo -> {archivo, ....}
  // progreso -> clases[] -> let item clase = {modulo -> {archivo, ....} ; completado -> 1,0 }

  // informacion examen

  preguntas = [];

  // Flags para edicion
  sesionTab = 0;
  editar = 0;

  // auxiliares para cargar fotos
  downloadURL: any;
  fire: any;

  // info de usuario
  usuario = JSON.parse(localStorage.getItem('user'))

  ngOnInit(): void {
    this.verificarEdicionOCreacion();
  }

  async verificarEdicionOCreacion() {
    await this.cargarInstructores();
    await this.cargarCategorias();
    if (this.id == null) {
      this.inicializarCrearCurso();
    } else {
      this.inicializarEditarCurso();
    }
  }

  // INICIALIZACION DE CREAR CURSO

  inicializarCrearCurso() {
    this.sesionTab = 0;
    this.editar = 0;
    this.loaded = 1;
  }

  /// INICIALIZACION DE EDICION DE CURSO //

  async inicializarEditarCurso() {
    this.sesionTab = 1;
    this.editar = 1
    await this.cargarCurso();
    await this.cargarSesion();
  }

  async cargarCurso() {
    return this.afs.collection('cursos').doc(this.id).ref.get().then(doc => {
      const curso = doc.data();
      this.curso = {
        descripcion: curso['descripcion'], //
        adicionales: curso['adicionales'], //
        cantArchivos: curso['cantArchivos'],
        cantVentas: curso['cantVentas'],
        categoria: curso['categoria'], //
        creador: curso['creador'],
        dictaEmpresa: curso['dictaEmpresa'], //
        dirigidoA: curso['dirigidoA'], //
        duracion: curso['duracion'],
        empresaDescripcion: curso['empresaDescripcion'],
        empresaFoto: curso['empresaFoto'],
        empresaId: curso['empresaId'],
        empresaNombre: curso['empresaNombre'],
        empresaResumen: curso['empresaResumen'],
        fechaCreacion: curso['fechaCreacion'],
        foto: curso['foto'], //
        idioma: curso['idioma'], //
        instructorDescripcion: curso['instructorDescripcion'],
        instructorFoto: curso['instructorFoto'],
        instructorId: curso['instructorId'],
        instructorNombre: curso['instructorNombre'],
        instructorResumen: curso['instructorResumen'],
        nivel: curso['nivel'],
        porcentajeDescuento: curso['porcentajeDescuento'], //
        instructorPorcentaje: curso['instructorPorcentaje'],
        precioFinal: curso['precioFinal'], //
        precioOriginal: curso['precioOriginal'], //
        publicado: curso['publicado'], //
        queAprenderas: curso['queAprenderas'], //
        resumen: curso['resumen'], //
        titulo: curso['titulo'], //
        ultimaEdicion: curso['ultimaEdicion'],
        ultimoEditor: curso['ultimoEditor'],
        valoracion: curso['valoracion'],
      }
      console.log(this.curso)
      this.loaded = 1;
    }).catch(error => {
      console.log(error)
    });
  }

  async cargarSesion() {
    return this.afs.collection('sesiones').doc(this.id).ref.get().then(doc => {
      const sesion = doc.data();
      this.clases = sesion['clases'];
      this.duracion = sesion['duracion']
    }).catch(error => {
      console.log(error)
    })
  }

  /// FUNCIONALIDADES ///////////////////////////////

  // Armar array de instructores

  async cargarInstructores() {
    console.log('entre')
    return this.afs.collection('instructores').ref.get().then(response => {
      response.docs.forEach(doc => {
        const data = doc.data();
        const instructor: instructor = {
          id: doc.id,
          nombre: data['nombre'],
          foto: data['foto'],
          descripcion: data['descripcion'],
          resumen: data['resumen'],
          categorias: data['categorias'],
          empresaId: data['empresaId'],
          empresaNombre: data['empresaNombre'],
          empresaDescripcion: data['empresaDescripcion'],
          empresaFoto: data['empresaFoto'],
          empresaResumen: data['empresaResumen'],
        }
        this.instructores = this.instructores.concat(instructor)
      })
    }).then(() => {
      console.log(this.instructores)
    }).catch(error => {
      console.log(error)
    })
  }

  async cargarCategorias() {
    return this.afs.collection('global').doc('global').ref.get().then((snap) => {
      const data = snap.data();
      this.categorias = data['categoria']
    }).catch(error => console.log(error));
  }

  // Metodos para el formulario

  anadirQueAprenderas() {
    const emptyString = '';
    this.curso.queAprenderas = this.curso.queAprenderas.concat(emptyString);
  }

  anadirAdicionales() {
    const emptyString = '';
    this.curso.adicionales = this.curso.adicionales.concat(emptyString);
  }

  eliminarQueAprenderas(i) {
    this.curso.queAprenderas.splice(i, 1)
  }

  eliminarAdicionales(i) {
    this.curso.adicionales.splice(i, 1)
  }

  cargarFoto(event, campo) {
    const file = event.target.files[0];
    let nombre: string = file.name;
    nombre = nombre.replace(' ','-')
    const filePath = `Cursos/${this.id}/${nombre}`;
    const fileRef = this.storage.ref(filePath);
    const task = this.storage.upload(`Cursos/${this.id}/${nombre}`, file);
    task
      .snapshotChanges().pipe(
        finalize(() => {
          this.downloadURL = fileRef.getDownloadURL();
          this.downloadURL.subscribe(url => {
            if (url) { this.fire = url; }
            console.log(this.fire)
            if (campo == "foto") {
              this.curso.foto = url;
            }
          });
        })
      )
      .subscribe(url => {
        if (url) {
          console.log(url);
        }
      });
  }

  cambioInstructor() {
    console.log("cambio instructor")
    const idx = this.instructores.findIndex(x => x.id == this.curso.instructorId);
    this.instructor = this.instructores[idx];
    if (this.curso.dictaEmpresa == true) {
      this.curso.empresaId = this.instructor.empresaId;
      this.curso.empresaNombre = this.instructor.empresaNombre;
      this.curso.empresaDescripcion = this.instructor.empresaDescripcion;
      this.curso.empresaResumen = this.instructor.empresaResumen;
      this.curso.empresaFoto = this.instructor.empresaFoto;
    } else {
      this.curso.empresaId = null;
      this.curso.empresaNombre = null;
      this.curso.empresaDescripcion = null;
      this.curso.empresaResumen = null;
      this.curso.empresaFoto = null;
    }
    this.curso.instructorId = this.instructor.id;
    this.curso.instructorNombre = this.instructor.nombre;
    this.curso.instructorFoto = this.instructor.foto;
    this.curso.instructorResumen = this.instructor.resumen;
    this.curso.instructorDescripcion = this.instructor.descripcion;
  }

  /// GUARDADO DEL CURSO

  guardarCurso() {
    /// Curso nuevo creado
    if (this.editar == 0) {
      this.id = this.curso.titulo.split(' ').join('-');
      this.curso.creador = this.usuario.uid;
      this.curso.fechaCreacion = new Date();
    }
    this.curso.precioFinal = +(this.curso.precioOriginal * (100 - this.curso.porcentajeDescuento) * 0.01).toFixed(2)
    this.curso.ultimaEdicion = new Date();
    this.curso.ultimoEditor = this.usuario.uid;


    this.afs.collection('cursos').doc(this.id).set(this.curso, { merge: true }).then(async () => {
      await this.actualizarCategorias();
      if (this.editar == 0) {
        await this.crearSesion();
        await this.crearSesionVisitantes();
        await this.crearExamen();
      }
      this.dialogService.dialogExito().afterClosed().subscribe(res => {
        if (this.editar == 0) {
          this.router.navigate(['editar-curso', this.id]);
        }
      })
    })
  }


    onDelete() {
      this.dialogService.dialogConfirmar().afterClosed().subscribe(res => {
        if (res == true) {
          this.afs.collection('cursos').doc(this.id).delete().then(() => {
            this.dialogService.dialogExito().afterClosed().subscribe(res => {
              this.router.navigate(['admin/lista-cursos']);
            })
          }).catch(error => {
            this.dialogService.dialogFracaso()
            console.log(error)
          });
        }
      });
    }

    async cargarEmpresaCategoria() {
      return this.afs.collection("empresas").doc(this.curso.empresaId).ref.get().then(snap => {
        const data = snap.data()
        return data["categorias"]
      });
    }

    async guardarCategoriaEmpresa(categorias) {
      return this.afs.collection("empresas").doc(this.instructor.empresaId).update({
        categorias: categorias,
      })

    }

    async cargarInstructorCategoria() {
      return this.afs.collection("instructores").doc(this.curso.instructorId).ref.get().then(snap => {
        const data = snap.data()
        return data["categorias"]
      });
    }

    async guardarCategoriaInstructor(categorias) {
      return this.afs.collection("instructores").doc(this.instructor.id).update({
        categorias: categorias,
      })

    }

    async actualizarCategorias() {
      let categorias = await this.cargarInstructorCategoria();
      if (categorias.includes(this.curso.categoria) == false) {
        categorias = categorias.concat(this.curso.categoria)
        await this.guardarCategoriaInstructor(categorias);
      }
      if (this.curso.dictaEmpresa == true) {
        categorias = await this.cargarEmpresaCategoria();
        if (categorias.includes(this.curso.categoria) == false) {
          categorias = categorias.concat(this.curso.categoria);
          await this.guardarCategoriaEmpresa(categorias)
        }
      }
    }

    async crearSesion(){
      return this.afs.collection('sesiones').doc(this.id).set({
        duracion: 0,
        clases: [],
      }).catch(error => console.log(error))
    }

    async crearSesionVisitantes(){
      return this.afs.collection('sesionesVisitante').doc(this.id).set({
        clases: [],
        duracion: 0,
      }).catch(error => console.log(error));
    }

    async crearExamen() {
      return this.afs.collection('examen').doc(this.id).set({
        preguntas: this.preguntas,
      }).catch(error => console.log(error))
    }

  }

